export default {"src":"/_next/static/media/checkmark-square-none.74f7d096.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};